import { FC, InputHTMLAttributes } from 'react';
import { css } from '@bts-web/utils-style-engine';

const BorderedTextInput: FC<InputHTMLAttributes<HTMLInputElement>> = (
  props,
) => {
  return (
    <input
      {...props}
      className={css({
        borderColor: 'neutrals.fill_tertiary',
        borderRadius: '4px',
        borderWidth: '1px',
        _disabled: {
          backgroundColor: 'neutrals.fill_disabled',
        },
        _focus: {
          borderColor: 'neutrals.fill_primary',
          boxShadow: '0 0 0 2px rgba(0, 123, 255, 0.25)',
        },
        _hover: {
          borderColor: 'neutrals.fill_secondary',
        },
        p: 'extra_small',
      })}
    />
  );
};

export { BorderedTextInput };
